export default __webpack_public_path__ + "static/media/m_engineering_card10_2.24a980cd.png";